import elementoVisivel from '../dom';

const FORM = '[data-tour="recursos-form-contrarrazoes"]';
const MENSAGEM = '[data-tour="recursos-form-contrarrazoes-mensagem"]';
const UPLOAD = '[data-tour="recursos-form-contrarrazoes-upload"]';
const ENVIAR = '[data-tour="recursos-enviar-contrarrazoes"]';

export default {
  id: 'recursos-form-contrarrazoes',
  kind: 'tour',
  version: 1,
  label: 'Apresentar contrarrazões',
  contexts: ['auction.recursos'],
  scopes: ['form-contrarrazoes'],
  priority: 20,
  help: true,
  canQueue(ctx = {}) {
    return Boolean(ctx.logged && ctx.podeContrarrazoar);
  },
  canStart(ctx = {}) {
    if (!ctx.logged || !ctx.formVisible) return false;
    if (ctx.podeContrarrazoar === false) return false;
    return Boolean(elementoVisivel(FORM));
  },
  steps() {
    const steps = [
      {
        element: FORM,
        popover: {
          title: 'Apresentar contrarrazões',
          description:
            'Na janela de contrarrazões, você pode se manifestar sobre o recurso de outro licitante.',
          side: 'top',
          align: 'start',
        },
      },
    ];

    if (elementoVisivel(MENSAGEM)) {
      steps.push({
        element: MENSAGEM,
        popover: {
          title: 'Contrarrazões',
          description: 'Escreva sua manifestação em resposta ao recurso. Campo obrigatório.',
          side: 'top',
          align: 'start',
        },
      });
    }

    if (elementoVisivel(UPLOAD)) {
      steps.push({
        element: UPLOAD,
        popover: {
          title: 'Anexos',
          description: 'Anexe documentos de suporte às contrarrazões, se houver.',
          side: 'left',
          align: 'start',
        },
      });
    }

    if (elementoVisivel(ENVIAR)) {
      steps.push({
        element: ENVIAR,
        popover: {
          title: 'Enviar Contrarrazões',
          description:
            'Após o envio, enquanto a janela estiver aberta, você poderá editar ou excluir suas contrarrazões.',
          side: 'top',
          align: 'start',
        },
      });
    }

    return steps;
  },
};
